import Compressor from 'compressorjs';
import { blobToBase64, urlToFile } from '@/utils/file';
export default {
  props: {
    src: {
      type: String,
      default: ''
    },
    poster: {
      type: String,
      default: ''
    },
    width: {
      type: Number
    },
    height: {
      type: Number
    },
    millisecond: {
      type: Number,
      default: 1000
    }
  },
  components: {},
  data() {
    return {
      src90: ''
    };
  },
  computed: {
    styles() {
      if (!this.src90) return {};
      const backgroundImage = `url(${this.src90})`;
      return {
        backgroundImage
      };
    }
  },
  methods: {
    getUrl(src) {
      if (this.poster) return this.poster;
      if (!src) return '';
      if (!/^http/.test(src)) return;
      const width = this.width ? `,w_${this.width}` : '';
      const height = this.height ? `,h_${this.height}` : '';
      return `${src.split('?')[0]}?x-oss-process=video/snapshot,t_${this.millisecond}${width}${height},f_jpg&t=${new Date().getTime()}`;
    },
    async rotate90(src) {
      if (!src) return;
      const url = this.getUrl(src);
      const file = await urlToFile(url);
      const blob = await new Promise((resolve, reject) => {
        return new Compressor(file, {
          success: resolve,
          error: reject
        });
      });
      const base64 = await blobToBase64(blob);
      this.src90 = base64;
    }
  },
  created() {
    this.src90 = this.getUrl(this.src);
    this.rotate90(this.src);
  },
  mounted() {},
  beforeUnmount() {},
  watch: {
    src(newValue) {
      this.src90 = this.getUrl(newValue);
      this.rotate90(newValue);
    }
  }
};